import React from "react";
import './Notification.scss';
import lang from '../../i18/lang';


class Notification extends React.Component {
    render() {

        const {isSuccessful, open} = this.props;

        return (
           <div className={open ? 'notification-wrapper' : 'hidden'} onClick={this.props.onClose}>
               <div className={(isSuccessful ? 'success' : 'error') + ' notification-content'}
                    onClick={(e) => e.stopPropagation()}>
                   <h4 hidden={!isSuccessful}>{lang.srb.section.notification.success_title}</h4>
                   <p hidden={!isSuccessful}>{lang.srb.section.notification.success_description}</p>

                    <h4 hidden={isSuccessful}>{lang.srb.section.notification.error_title}</h4>
                    <p hidden={isSuccessful}>{lang.srb.section.notification.error_description}</p>
               </div>
           </div>
        )
    }
}

export default Notification;